// Правила вывода реферальных — те же, что проверяет сервер
// (CustomUser.available_for_withdrawal и WithdrawalRequest.MIN_AMOUNT).
//
// «Your rewards» — это начисленное и ещё не выплаченное. Висящая заявка эти
// деньги уже резервирует, поэтому запросить можно только остаток. Раньше страница
// показывала одну цифру ($296) и молча блокировала кнопку, а причину писала во
// всплывающей подсказке, которую на телефоне не увидеть.

export const MIN_WITHDRAWAL = 100;

const cents = n => Math.round((Number(n) || 0) * 100) / 100;

export function formatMoney(n) {
  return `$${cents(n).toFixed(2)}`;
}

export function withdrawalState({ balance, pending, amount, zelle }) {
  const reserved = cents(pending);
  const available = Math.max(0, cents(cents(balance) - reserved));
  const requested = cents(parseFloat(amount));
  const hasZelle = (zelle || '').trim().length > 0;

  let reason = '';
  if (available < MIN_WITHDRAWAL) {
    reason = reserved > 0
      ? `Your withdrawal of ${formatMoney(reserved)} is being processed. You can request a new one ` +
        `once your available balance reaches ${formatMoney(MIN_WITHDRAWAL)}.`
      : `You can request a withdrawal once your available balance reaches ${formatMoney(MIN_WITHDRAWAL)}.`;
  } else if (requested < MIN_WITHDRAWAL) {
    reason = `Enter an amount of at least ${formatMoney(MIN_WITHDRAWAL)}.`;
  } else if (requested > available) {
    reason = `You can request up to ${formatMoney(available)}.`;
  } else if (!hasZelle) {
    reason = 'Enter your Zelle phone number or email.';
  }

  return { available, reserved, disabled: Boolean(reason), reason };
}

/** Текст ошибки из ответа DRF: {"amount": ["..."]}, {"detail": "..."} и т.п. */
export function apiErrorText(body, fallback) {
  const pick = value => (Array.isArray(value) ? value.join(' ') : value);
  return pick(body?.amount) || pick(body?.detail) || pick(body?.non_field_errors) || fallback;
}
